<template>
  <el-dialog class="purchased-dialog" :visible.sync="dialogVisible" width="900px" :close-on-click-modal="false">
    <div slot="title" class="dialog-title">请选择课程</div>
    <div class="purchased-content">
      <div v-for="(item, index) in purchasedList" :key="item.id || index" class="purchased-item" :class="{ 'expired': isExpired(item.validityTime) }" @click="handleSelectCourse(item)">
        <div class="classView">
          <div class="flex-c box">
            <div class="item-validPeriod" v-if="item.validityTime">
              课程有效期：{{ calculateTheValidityPeriod(item.validityTime) }}
            </div>
            <img class="item-img" :src="item.img || 'https://via.placeholder.com/205x115'" />
            <div class="course_type">
              <span v-if="item.type == 1 || item.type == 16">
                {{ item.productLine === "5" ? "1V1直播" : "知识套餐" }}
              </span>
              <span v-else>精品课程</span>
            </div>
            <div class="item-centent">
              <div class="item_name-box">
                <div class="item-text elp">{{ item.name }}</div>
              </div>
              <div class="tips">
                <template v-if="item.type == 1">
                  <div v-if="item.productLine !== '5'" class="item-tips elp">
                    共{{ item.courseNum || 0 }}门课
                  </div>
                </template>
              </div>
              <div v-if="(item.type == 1 || item.type == 16) && getCoufig(item).length > 0" class="typeList">
                <div class="type-name">特色服务：</div>
                <div class="type-coufig">
                  <span v-for="(coufig, coufigIndex) in getCoufig(item)" :key="coufigIndex">
                    {{ coufigIndex ? "、" : "" }}{{ coufig }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "CourseSelector",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    purchasedList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    calculateTheValidityPeriod(time) {
      if (!time) return "已过期";
      const currentTime = new Date();
      time = time ? time.toString().replace(/-/g, "/") : time;
      const targetTime = new Date(time);
      const difference = targetTime.getTime() - currentTime.getTime();
      if (difference < 0) {
        return "已过期";
      }
      const year = Math.floor(difference / 1000 / 60 / 60 / 24 / 365);
      const days = Math.floor(difference / 1000 / 60 / 60 / 24) - Math.floor(year * 365);
      return year + "年" + days + "天";
    },
    isExpired(time) {
      if (!time) return true;
      const currentTime = new Date();
      time = time ? time.toString().replace(/-/g, "/") : time;
      const targetTime = new Date(time);
      return targetTime.getTime() - currentTime.getTime() < 0;
    },
    handleSelectCourse(item) {
      if (this.isExpired(item.validityTime)) {
        this.$message.warning('当前班型课程已过期，请切换其他班型课程');
        return;
      }
      this.$emit('select-course', item);
    },
    getCoufig(item) {
      if (item.coufig && item.coufig.length > 0) {
        return item.coufig;
      }
      const data = [];
      if (item.type == 1 || item.type == 16) {
        if (item.isData == 0) {
          data.push("专属资料");
        }
        if (item.isQuestion == 0) {
          data.push("专属题库");
        }
        if (item.isExamination == 0) {
          data.push("专属考场");
        }
        if (item.isTeaching == 0) {
          data.push("专属教材");
        }
        if (item.isReference == 0) {
          data.push("专属教服");
        }
      }
      return data;
    }
  }
};
</script>

<style lang="less" scoped>
.purchased-dialog {
  /deep/ .el-dialog {
    margin-top: 20vh !important;
    border-radius: 20px;
    overflow: hidden;
  }

  /deep/ .el-dialog__header {
    border-radius: 20px 20px 0 0;
  }

  /deep/ .el-dialog__footer {
    border-radius: 0 0 20px 20px;
  }
}

.dialog-title {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
}

.purchased-content {
  max-height: 500px;
  overflow-y: auto;

  .purchased-item {
    margin-bottom: 16px;
    cursor: pointer;

    &.expired {
      .classView {
        background: #f5f5f5;
        opacity: 0.6;

        &:hover {
          background-color: #f5f5f5;
          border-color: #eeeeee;

          .item-text {
            color: #333333 !important;
          }
        }
      }
    }

    /* 班型 */
    .classView {
      width: 100%;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      border: 1px solid #eeeeee;
      padding: 6px;

      &:hover {
        background-color: #f8f9fa;
        border-color: #4a6af0;

        .item-text {
          color: #0372e9 !important;
        }
      }

      .box {
        position: relative;
        display: flex;

        .item-img {
          width: 140px;
          height: 80px;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          flex-shrink: 0;
          margin-right: 20px;
        }

        .item-centent {
          flex: 1;
          height: auto !important;

          .item_name-box {
            display: flex;
            align-items: center;

            .item-text {
              height: 14px;
              font-size: 14px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #333333;
              line-height: 14px;
            }
          }

          .tips {
            display: flex;
            align-items: center;
            margin-top: 12px;

            .item-tips {
              height: 16px;
              border-radius: 8px 8px 8px 8px;
              opacity: 1;
              border: 1px solid #b9bfc4;
              font-size: 9px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #777a82;
              line-height: 14px;
              padding: 0 6px;
            }
          }
        }
      }
    }
  }

  /* 专属 */
  .typeList {
    margin-top: 16px;
    width: fit-content;
    padding-right: 8px;
    height: 28px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    background-image: url("~@/assets/img/partner/zhuanshu-bg.png");
    background-size: 300px 28px;

    .type-name {
      margin-left: 8px;
      height: 28px;
      font-size: 11px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #818395;
      line-height: 28px;
    }

    .type-coufig {
      height: 28px;
      font-size: 11px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #818395;
      line-height: 28px;
    }
  }

  /* 课程有效期： */
  .item-validPeriod {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    top: -6px;
    right: -6px;
    width: 130px;
    height: 22px;
    background: url("~@/assets/img/partner/typebac.png") no-repeat;
    background-size: 100%;
    opacity: 1;
    font-size: 11px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #458bd8;
  }

  .course_type {
    width: 48px;
    height: 18px;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 6px 0 6px 0;
    color: #ffffff;
    font-size: 10px;
    text-align: center;
    line-height: 18px;
  }
}

.elp {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::-webkit-scrollbar {
  width: 0 !important;
}
</style>
